import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import history from '../../helpers/history';

import { Layout, PageHeader, Select, Button, Form, Divider, Spin, Modal, Progress } from 'antd';

import OptResult from './OptResult';

import emitter from '../Evt.js';

import TooltipPage from '../../pannels/account/TooltipPage';

const { Content } = Layout;

var languageMessages = window.appLocale.messages;

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

class OptimalOptPage extends Component {
    constructor(props) {
        super(props);

        this.backtestId = "0";
        if (history.location.state !== undefined) {
            this.backtestId = history.location.state.backtestId;
        }

        this.user = {};
        this.state = {

            symbolCode: '',
            symbolName: '',

            latestPrice: 0,
            quoteChange: 0,
            
            priceRange: '',

            backtestRange: '',

            dayTradeOnly: '0',

            lastTimes: 0,
            type: 3,

            spinLoadding: true,

            filterError: '',

            isStartOptimized: false,

            backtestStatus: 0,

            statisticsResult: [],

            consuming: 0,
            percent: 0,
        };
    }

    componentDidMount() {
        emitter.addListener('initPage', this.init);
        emitter.addListener("callSendBacktestError", this.callSendBacktestError);
        emitter.addListener("callOptimalOptError", this.callOptimalOptError);
        emitter.addListener('callOptimalOptLastTimes', this.callOptimalOptLastTimes);
        emitter.addListener('callOptimalOptStatus', this.callOptimalOptStatus);
        emitter.addListener('callOptimalOptResult', this.callOptimalOptResult);
    }

    componentWillMount() {
        this.init();
    }

    componentWillUnmount() {
        emitter.removeListener('initPage', this.init);
        emitter.removeListener('callSendBacktestError', this.callSendBacktestError);
        emitter.removeListener('callOptimalOptError', this.callOptimalOptError);
        emitter.removeListener('callOptimalOptLastTimes', this.callOptimalOptLastTimes);
        emitter.removeListener('callOptimalOptStatus', this.callOptimalOptStatus);
        emitter.removeListener('callOptimalOptResult', this.callOptimalOptResult);
    }

    callSendBacktestError = () => {
        this.setState({ spinLoadding: false });
    }

    callOptimalOptError = (status) => {
        var error = status !== undefined ? strReplace(languageMessages['backtestFail'], { '{num}': status }) : '';
        this.setState({ spinLoadding: false, filterError: error });
    }

    callOptimalOptLastTimes = (lastTimes, permission) => {
        if (this.user.permission !== undefined) {
            this.user.permission = permission;
            sessionStorage.setItem("auth", JSON.stringify(this.user));
        }

        this.setState({ lastTimes, backtestStatus: 1, spinLoadding: false });
    }

    keepDecimals(value, sign) {
        value = value == null ? '' : value;
        if (value !== '') {
            if (value > 0) {
                value = value.replace(/([0-9]+.[0-9]{2})[0-9]*/, "$1");
            }
            value += sign;
        }

        return value;
    }

    callOptimalOptStatus = (backtestStatus) => {
        backtestStatus = JSON.parse(backtestStatus || '{}');

        var consuming = parseInt(backtestStatus['consuming']);
        var percent = parseInt(backtestStatus['percent']);
        var backtestStatus = percent > 0 ? 2 : 1;

        this.setState({ backtestStatus, consuming, percent, spinLoadding: false });
    }

    callOptimalOptResult = (backtestResult, backtest) => {
        backtestResult = JSON.parse(backtestResult || '[]');

        var statisticsResult = this.setBacktestResult(backtestResult, backtest);
        this.setState({ backtestStatus: 3, statisticsResult, spinLoadding: false, percent: 100 });

        /**
        let { consuming, percent } = this.state;
        if (consuming == 0 && percent == 0) {
            if (backtestResult.length > 0) {
                this.setProgress(backtestResult, backtest);
            } else {
                var statisticsResult = [];
                this.setState({ backtestStatus: 3, statisticsResult, spinLoadding: false, percent: 100 });
            }
        } else {
            var statisticsResult = [];
            if (backtestResult.length > 0) {
                statisticsResult = this.setBacktestResult(backtestResult, backtest);
            }

            this.setState({ backtestStatus: 3, statisticsResult, spinLoadding: false, percent: 100 });
        }
        */
    }

    setProgress(backtestResult, backtest) {
        var total = Math.ceil(Math.random() * (45 - 30 + 1) + 30);
        var step = Math.ceil(Math.random() * (8 - 5 + 1) + 5);

        var stepKey = Math.ceil((total - 5) / step);
        var setepValue = Math.ceil(100 / step);

        var tmpStepKey = stepKey;
        var tmpSetepValue = setepValue;

        var percentMap = { 1: 5 };

        stepKey += 1;
        setepValue += 5;
        percentMap[stepKey] = setepValue;
        for (var ii = 0; ii < step; ii++) {
            var stepKey1 = stepKey + tmpStepKey;

            stepKey += 1;
            stepKey = Math.ceil(Math.random() * (stepKey1 - stepKey + 1) + stepKey);

            var setepValue1 = setepValue + tmpSetepValue;

            setepValue += 1;
            setepValue = Math.ceil(Math.random() * (setepValue1 - setepValue + 1) + setepValue);

            if (ii + 1 >= step && setepValue < 98) {
                setepValue = Math.ceil(Math.random() * (98 - setepValue + 1) + setepValue);
            }
            percentMap[stepKey] = setepValue;
        }

        var consuming = 0;
        var percent = 0;
        this.setProgressStatus(total, consuming, percent, percentMap, backtestResult, backtest);
    }

    setProgressStatus(total, consuming, percent, percentMap, backtestResult, backtest) {
        if (this.state.backtestStatus === 0) return;

        consuming += 1;
        if (consuming >= total) {
            var statisticsResult = this.setBacktestResult(backtestResult, backtest);
            this.setState({ backtestStatus: 3, statisticsResult, spinLoadding: false, percent: 100 });
        } else {
            if (percentMap.hasOwnProperty(consuming)) percent = percentMap[consuming];

            var _this = this;
            this.setState({ backtestStatus: 2, consuming, percent, spinLoadding: false }, () => {
                setTimeout(function () { _this.setProgressStatus(total, consuming, percent, percentMap, backtestResult, backtest); }, 1000);
            });
        }
    }

    setBacktestResult(backtestResult, backtest) {
        var statisticsResult = [];

        for (var item in backtestResult) {
            var br = backtest.GridStrategys.filter(function (e) { return e.BacktestId === backtestResult[item]['backtestId']; });
            if (br[0].StrategyName.indexOf('strategy') == -1) continue;

            //var strategyName = backtestResult[item]['strategyName'];
            //if (strategyName.indexOf('strategy') == -1) continue;

            var trades = backtestResult[item]['trades'];
            for (var ii in trades) {
                trades[ii]['backtestId'] = backtestResult[item]['backtestId'];
                trades[ii]['symbol'] = backtestResult[item]['symbol'];
            }

            statisticsResult.push({
                backtestId: backtestResult[item]['backtestId'],
                batchId: backtestResult[item]['batchId'],
                strategyName: br[0].StrategyName,

                symbol: backtest.SymbolCode,
                symbolName: backtest.SymbolName,
                dayTradeOnly: backtest.DayTradeOnly,

                targetDistance: backtestResult[item]['targetDistance'],
                stopDistance: backtestResult[item]['stopDistance'],
                maxHoldingPeriod: backtestResult[item]['maxHoldingPeriod'],

                priceRange: '',
                gridCnt: br[0].GridCnt,
                gridWidth: '',

                capital: br[0].Capital,

                //oInitialRateOfReturnOnCapital: backtestResult[item]['oStatistics'].initialRateOfReturnOnCapital,
                //oAnnualizedRateOfReturn: backtestResult[item]['oStatistics'].annualizedRateOfReturn,

                initialRateOfReturnOnCapital: backtestResult[item]['statistics'].initialRateOfReturnOnCapital,
                annualizedRateOfReturn: backtestResult[item]['statistics'].annualizedRateOfReturn,

                //totalPnl: backtestResult[item]['statistics'].totalPnl,

                //oProfitFactor: backtestResult[item]['oStatistics'].profitFactor,
                profitFactor: backtestResult[item]['statistics'].profitFactor,

                //maxDrawdown: backtestResult[item]['statistics'].maxDrawdownPercent,
                //totalTrades: backtestResult[item]['statistics'].totalTrades,

                //oEquityCurve: backtestResult[item]['oEquityCurve'],
                equityCurve: backtestResult[item]['equityCurve'],
                trades: trades
            });
        }

        return statisticsResult;
    }

    init = () => {
        this.user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};

        var userId = this.user.username === undefined ? '' : this.user.username;
        this.props.dispatch({ type: "action_get_opt_info", payload: { u: userId, b: this.backtestId } });
    }

    setUserPermission(permissions) {
        var lastTimes = 0;
        for (var key in permissions) {
            var permission = permissions[key];
            switch (permission.type) {
                case 'bo':
                    lastTimes += permission.totalCount - permission.usageCount;
                    break;
                default:
                    lastTimes += 0;
                    break;
            }
        }

        return lastTimes;
    }

    componentWillReceiveProps(props) {
        var { status, optInfo, permission } = props;

        switch (status) {
            case 'get_opt_info_success':
                var lastTimes = 0;
                if (this.user.permission !== undefined) {
                    this.user.permission = permission;
                    sessionStorage.setItem("auth", JSON.stringify(this.user));
                    lastTimes = this.setUserPermission(this.user.permission);
                }

                var symbolCode = '';
                var latestPrice = 0;
                var quoteChange = 0;
                var priceRange = '';
                var backtestRange = '';
                var dayTradeOnly = '0';
                var isStartOptimized = false;
                if (optInfo != undefined) {
                    symbolCode = optInfo.symbol;
                    latestPrice = optInfo.latestPrice;
                    quoteChange = optInfo.quoteChange;
                    priceRange = optInfo.priceRange;
                    backtestRange = optInfo.backtestRange;
                    dayTradeOnly = optInfo.dayTradeOnly;

                    //this.onStartOptimized();
                    isStartOptimized = true;
                }

                this.setState({ symbolCode, latestPrice, quoteChange, priceRange, backtestRange, dayTradeOnly, isStartOptimized, lastTimes, spinLoadding: false });
                break;
            case 'get_opt_info_fail':

                this.setState({ spinLoadding: false });
                break;
            default:
                this.setState({ spinLoadding: false });
                break;
        }
    }

    getCapital(tmpLower, tmpUpper, gridCnt) {
        if (window.webType === 'US') {
            let gridWidth = 0;
            let capital = 0;

            return { gridWidth, capital };
        } else {
            let baseNumber = 100;

            let priceRange = tmpUpper - tmpLower;

            let tmpGridCnt = parseInt(gridCnt);
            let gridWidth = priceRange / tmpGridCnt;

            let tmpPrice = (tmpGridCnt + 1) / 2;
            tmpPrice = parseInt(tmpPrice);

            let comm = Math.ceil(tmpPrice * 5 / 0.0003 / 1000) * 1000;

            let capital = (tmpLower + tmpLower + (tmpPrice - 1) * gridWidth) * tmpPrice / 2 * baseNumber;
            capital = Math.ceil(capital);

            capital = Math.max(comm, capital);

            return { gridWidth, capital };
        }
    }

    onStartOptimized = () => {
        if (this.user.username === undefined) {
            this.setState({
                filterError: '',
                spinLoadding: false,
            }, () => {
                this.props.dispatch({ type: "action_non_user" });
            });
        } else {
            let { symbolCode, symbolName, lastTimes, latestPrice } = this.state;

            if (lastTimes <= 0) {
                var content = <span>{languageMessages['todayBatchBacktestNumberRunOut']}，{languageMessages['please go']}<a onClick={this.onValueAddedServices}>{languageMessages['value-added.services']}</a></span>;
                Modal.info({
                    title: languageMessages['prompt'],
                    content: content
                });
                return;
            }

            this.setState({
                backtestStatus: 0,
                statisticsResult: [],
                consuming: 0,
                percent: 0,
                spinLoadding: true,
                filterError: ''
            }, () => {
                this.props.dispatch({
                    type: "action_send_hub_message", payload: {
                        service: 'SendBacktest', userId: this.user.username,
                        msg: {
                            Type: 'optimalOpt',
                            SymbolCode: symbolCode,
                            SymbolName: '',
                            BacktestId: this.backtestId,
                            BacktestType: this.state.type,
                            Last: latestPrice,
                            ReqId: guid()
                        }
                    }
                });
            });
        }
    }

    render() {
        var { percent } = this.state;

        return (<Content className='main-container total-content'>
            <Helmet>
                <title>{languageMessages['title']}</title>
                <meta name="keywords" content={languageMessages['keywords']} />
                <meta name="description" content={languageMessages['description']} />

                <meta property="og:title" content={languageMessages['title']} />
                <meta property="og:url" content="https://us.quancept.com/" />
                <meta property="og:type" content="website" />
                <meta name="og:description" content={languageMessages['description']} />

                <meta property="twitter:url" content="https://us.quancept.com/" />
                <meta name="twitter:title" content={languageMessages['title']} />
                <meta name="twitter:description" content={languageMessages['description']} />
                <meta name="twitter:site" content="https://us.quancept.com/" />
            </Helmet>
            <Spin spinning={this.state.spinLoadding}>
                <div className='common-page-header'>
                    <PageHeader title={(<h1>{languageMessages['optimalGrid'] + ' » ' + languageMessages['ScrollOptimization']}</h1>)} />
                </div>
                <div style={{ padding: '0px 50px', marginBottom: '20px' }}>
                    <div className='common-title'><Divider type="vertical" />{languageMessages['basic.info']}</div>
                    <div className='common-backtest-cont'>
                        <Form labelAlign={'left'} layout="inline" className={window.webType === 'US' ? 'common-form-hawkeye hawkeye-us' : 'common-form-hawkeye'}>
                            <Form.Item colon={false} label={languageMessages['symbolCode']} style={{ marginBottom: 0, marginRight: 32 }}>
                                <div>{this.state.symbolCode}</div>
                                <div style={{ position: 'relative', top: '-5px', height: '20px', lineHeight: '20px', fontSize: '10px' }}>
                                    {languageMessages['latest.price']}：<span style={{ color: this.state.quoteChange === 0 ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.85)', marginRight: '10px' }}>{this.state.latestPrice}</span>
                                    {languageMessages['quote.change']}：<span style={{ color: this.state.quoteChange === 0 ? 'rgba(0, 0, 0, 0.25)' : this.state.quoteChange >= 0 ? window.webType === 'US' ? 'green' : 'red' : window.webType === 'US' ? 'red' : 'green' }}>{this.state.quoteChange}%</span>
                                </div>
                            </Form.Item>
                        </Form>
                    </div>
                    <div className='common-backtest-cont'>
                        <Form labelAlign={'left'} layout="inline" style={{ padding: '8px 0' }} className={window.webType === 'US' ? 'common-form-hawkeye hawkeye-us' : 'common-form-hawkeye'}>
                            <Form.Item colon={false} label={languageMessages['priceRange']}>
                                {this.state.priceRange}
                            </Form.Item>
                        </Form>
                        <Form labelAlign={'left'} layout="inline" style={{ padding: '8px 0' }} className={window.webType === 'US' ? 'common-form-hawkeye hawkeye-us' : 'common-form-hawkeye'}>
                            <Form.Item>
                                {this.state.dayTradeOnly === '0' ? languageMessages['Cross-day trading only'] : languageMessages['Day trading only']}
                            </Form.Item>
                        </Form>
                    </div>
                    <div className='common-backtest-cont'>
                        <div style={{ marginBottom: '20px' }}>
                            <Form labelAlign={'left'} layout="inline" className={window.webType === 'US' ? 'common-form-hawkeye hawkeye-us' : 'common-form-hawkeye'}>
                                <Form.Item colon={false} label={languageMessages['backtestInterval']}>
                                    {this.state.backtestRange}
                                </Form.Item>
                            </Form>
                        </div>
                        <Button size='small' loading={false} disabled={!this.state.isStartOptimized} onClick={this.onStartOptimized}>
                            {languageMessages['startOptimized']}
                        </Button>
                        <TooltipPage lastTimes={this.state.lastTimes} filterError={this.state.filterError} />
                    </div>
                </div>
                <div style={{ backgroundColor: '#efefef', height: '48px', lineHeight: '48px', padding: '0 50px', display: this.state.backtestStatus > 0 ? 'block' : 'none' }}>
                    <div style={{ float: 'left' }}>
                        <b>{languageMessages['backtestStatus']}</b>
                        <span style={{ margin: '0 10px', display: this.state.backtestStatus == 1 ? 'inline-block' : 'none' }}>{languageMessages['queue']}</span>
                        <span style={{ display: this.state.backtestStatus == 2 ? 'inline-block' : 'none' }}>
                            <span style={{ margin: '0 10px' }}>{strReplace(languageMessages['optimizingConsuming'], { '{num}': this.state.consuming })}</span>
                            <span style={{ display: 'inline-block', width: '300px', margin: '0 10px' }}><Progress strokeColor={{ '0%': '#108ee9', '100%': '#87d068', }} percent={percent} /></span>
                        </span>
                        <span style={{ margin: '0 10px', display: this.state.backtestStatus == 3 ? 'inline-block' : 'none' }}>{strReplace(languageMessages['optimizedCompletedConsuming'], { '{num}': this.state.consuming })}</span>
                    </div>
                </div>
                <Content style={{ padding: '0px 50px', marginBottom: '50px' }}>
                    {this.state.statisticsResult.length == 0 || (<OptResult dispatch={this.props.dispatch} type={this.state.type} statisticsResult={this.state.statisticsResult} />)}
                </Content>
            </Spin>
        </Content>);
    }
}

function mapStateToProps(state) {
    return state.backtest;
}

const page = connect(mapStateToProps)(OptimalOptPage);
export { page as default }